import initialState, { State } from 'redux/initialState';
import types from 'redux/actions/actionTypes';
import { actionTypes as customTypes } from 'modules/_shared/redux/resetActions';

type AiAction = {
  type: string;
  conversations?: any[];
  conversation?: any;
  conversationId?: string;
  message?: any;
  usage?: any;
  isStreaming?: boolean;
  streamingText?: string;
  isHandoff?: boolean;
};

type AiState = State['ai'];
const baseInitialAi: AiState = initialState.ai as AiState;

const resetStateSociety = (state: AiState): AiState => {
  if (state.isStreaming || state.isHandoff) {
    return state;
  }
  return baseInitialAi;
};

const getAiConversations = (state: AiState, action: AiAction): AiState => ({
  ...state,
  conversations: action.conversations || [],
});

const getAiConversation = (state: AiState, action: AiAction): AiState => ({
  ...state,
  currentConversation: {
    id: action.conversation?.id || null,
    title: action.conversation?.title || '',
    messages: action.conversation?.messages || [],
  },
});

const deleteAiConversation = (state: AiState, action: AiAction): AiState => ({
  ...state,
  conversations: state.conversations.filter(
    (c: any) => c.id !== action.conversationId
  ),
  currentConversation:
    state.currentConversation.id === action.conversationId
      ? baseInitialAi.currentConversation
      : state.currentConversation,
});

const appendAiMessage = (state: AiState, action: AiAction): AiState => ({
  ...state,
  currentConversation: {
    ...state.currentConversation,
    messages: [...state.currentConversation.messages, action.message],
  },
});

const clearAiConversation = (state: AiState): AiState => ({
  ...state,
  currentConversation: baseInitialAi.currentConversation,
  isStreaming: false,
  streamingText: '',
  isHandoff: false,
});

const setAiHandoff = (state: AiState, action: AiAction): AiState => ({
  ...state,
  isHandoff: action.isHandoff ?? false,
});

const setAiStreaming = (state: AiState, action: AiAction): AiState => ({
  ...state,
  isStreaming: action.isStreaming ?? false,
  streamingText: action.streamingText ?? '',
});

const setAiConversationId = (state: AiState, action: AiAction): AiState => ({
  ...state,
  currentConversation: {
    ...state.currentConversation,
    id: action.conversationId ?? state.currentConversation.id,
  },
});

const setAiUsage = (state: AiState, action: AiAction): AiState => ({
  ...state,
  usage: action.usage || null,
});

export default function reducer(
  state: AiState = baseInitialAi,
  action: AiAction = { type: '' }
): AiState {
  switch (action.type) {
    case customTypes.RESET_STATE_SOCIETY:
      return resetStateSociety(state);
    case types.GET_AI_CONVERSATIONS:
      return getAiConversations(state, action);
    case types.GET_AI_CONVERSATION:
      return getAiConversation(state, action);
    case types.DELETE_AI_CONVERSATION:
      return deleteAiConversation(state, action);
    case types.APPEND_AI_MESSAGE:
      return appendAiMessage(state, action);
    case types.CLEAR_AI_CONVERSATION:
      return clearAiConversation(state);
    case types.SET_AI_USAGE:
      return setAiUsage(state, action);
    case types.SET_AI_STREAMING:
      return setAiStreaming(state, action);
    case types.SET_AI_CONVERSATION_ID:
      return setAiConversationId(state, action);
    case types.SET_AI_HANDOFF:
      return setAiHandoff(state, action);
    default:
      return state;
  }
}
